var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "40px",
    viewBox: "0 0 36 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1.4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.2--Password",
    transform: "translate(-333.000000, -601.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(333.000000, 601.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7647059,16.3312203 C31.7647059,24.3882726 26.4882353,31.659271 18,35 C9.51176471,31.659271 4.23529412,24.3882726 4.23529412,16.3312203 L4.23529412,7.09508716 C14.1,2.96830428 23.0470588,2.96830428 31.7647059,7.09508716 L31.7647059,16.3312203 Z M34.875,4.26729264 C24.525,-1.32218114 13.05,-1.52180521 1.125,4.26729264 L0,4.86616483 L0,16.6439846 C0,26.6251877 6.75,35.8098909 17.1,39.6007519 L18,40 L18.9,39.6007519 C29.25,35.6082706 36,26.6251877 36,16.6439846 L36,4.86616483 L34.875,4.26729264 Z",
    id: "Fill-1",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(10.588235, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.396389328,3.88572198 C-0.0998181689,4.37283439 -0.219159212,5.10864132 0.561791827,5.90199739 L3.99337026,9.38372068 C4.78897721,10.1894087 6.09754129,10.2079067 6.91408527,9.42277189 L14.4702577,2.15513697 C14.8952793,1.77079089 14.995777,0.8602812 14.4409458,0.364947485 C14.4409458,0.364947485 13.4171253,-0.64010723 12.0771557,0.685578438 L5.43383759,7.14547 L2.58849587,4.19402097 C1.38461692,3.01015284 0.396389328,3.88572198 0.396389328,3.88572198",
    id: "Fill-3",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.396389328,3.88572198 C-0.0998181689,4.37283439 -0.219159212,5.10864132 0.561791827,5.90199739 L3.99337026,9.38372068 C4.78897721,10.1894087 6.09754129,10.2079067 6.91408527,9.42277189 L14.4702577,2.15513697 C14.8952793,1.77079089 14.995777,0.8602812 14.4409458,0.364947485 C14.4409458,0.364947485 13.4171253,-0.64010723 12.0771557,0.685578438 L5.43383759,7.14547 L2.58849587,4.19402097 C1.38461692,3.01015284 0.396389328,3.88572198 0.396389328,3.88572198 Z",
    id: "Stroke-5",
    stroke: "#9B9B9B",
    strokeWidth: 0.75
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.404b16e82d6f59e15db41daaa0b8d064.svg";
export { ForwardRef as ReactComponent };